import { render, staticRenderFns } from "./FormCheckboxGroup.vue?vue&type=template&id=37c396ec&"
import script from "./FormCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./FormCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./FormCheckboxGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports